export default __webpack_public_path__ + "5865177a854eb112df24d5ded2516dd0.png";